(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};
  var editorEventsBound = false;

  window.SPCLST.modules.home = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;
    var on = helpers.on;
    var parseBool = helpers.parseBool;
    var isMobileViewport = helpers.isMobileViewport;
    var isDesktopNavViewport = helpers.isDesktopNavViewport;

    function bindEditorEvents() {
      if (editorEventsBound || !window.Shopify || !window.Shopify.designMode) return;
      editorEventsBound = true;

      function reinitializeHomeSections() {
        window.setTimeout(function () {
          if (!window.SPCLST || !window.SPCLST.modules || typeof window.SPCLST.modules.home !== 'function') return;
          window.SPCLST.modules.home(helpers);
        }, 80);
      }

      document.addEventListener('shopify:section:load', reinitializeHomeSections);
      document.addEventListener('shopify:section:select', reinitializeHomeSections);
      document.addEventListener('shopify:block:select', reinitializeHomeSections);
    }

    bindEditorEvents();

    queryAll('[data-spclst-featured-product-slider]').forEach(function (sliderRoot) {
      if (sliderRoot.getAttribute('data-spclst-initialized') === 'true') return;
      sliderRoot.setAttribute('data-spclst-initialized', 'true');

      var slides = queryAll('[data-spclst-featured-product-slide]', sliderRoot);
      var tabs = queryAll('[data-spclst-featured-product-tab]', sliderRoot);
      var autoplayEnabled = parseBool(sliderRoot.getAttribute('data-spclst-featured-product-autoplay'));
      var autoplayInterval = parseInt(sliderRoot.getAttribute('data-spclst-featured-product-interval') || '0', 10);
      var currentIndex = 0;
      var touchStartX = 0;
      var touchStartY = 0;
      var autoplayTimer = null;
      var fitTextRaf = null;

      if (!slides.length) return;

      function normalizeIndex(index) {
        var count = slides.length;
        if (!count) return 0;
        return ((index % count) + count) % count;
      }

      function setActiveSlide(nextIndex) {
        currentIndex = normalizeIndex(nextIndex);

        slides.forEach(function (slide, index) {
          var active = index === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        tabs.forEach(function (tab, index) {
          tab.classList.toggle('is-active', index === currentIndex);
        });
      }

      function clearAutoplay() {
        if (!autoplayTimer) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      function startAutoplay() {
        clearAutoplay();
        if (!autoplayEnabled) return;
        if (slides.length < 2) return;
        if (!(autoplayInterval >= 2000)) return;

        autoplayTimer = window.setInterval(function () {
          setActiveSlide(currentIndex + 1);
        }, autoplayInterval);
      }

      function restartAutoplay() {
        clearAutoplay();
        startAutoplay();
      }

      function handleFeaturedWheel(event) {
        if (event.ctrlKey) return;

        var dominantDeltaX = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (!dominantDeltaX || Math.abs(event.deltaX) < 2) return;

        event.preventDefault();
        if (event.deltaX > 0) {
          setActiveSlide(currentIndex + 1);
        } else {
          setActiveSlide(currentIndex - 1);
        }
        restartAutoplay();
      }

      function setFeaturedTabMobileScale(scaleValue) {
        sliderRoot.style.setProperty('--spclst-featured-tab-mobile-scale', String(scaleValue));
      }

      function tabTextOverflowsHorizontally(tab) {
        if (!tab) return false;
        var title = query('.hero-slider-heading', tab);
        var subtitle = query('.text-block-20', tab);
        var titleOverflow = !!title && title.scrollWidth - title.clientWidth > 1;
        var subtitleOverflow = !!subtitle && subtitle.scrollWidth - subtitle.clientWidth > 1;
        return titleOverflow || subtitleOverflow;
      }

      function fitFeaturedTabTypography() {
        setFeaturedTabMobileScale(1);

        if (!window.matchMedia('(max-width: 767px)').matches) return;
        if (!tabs.length) return;

        var minScale = 0.68;
        var step = 0.02;
        var scale = 1;

        while (scale >= minScale) {
          setFeaturedTabMobileScale(scale.toFixed(2));

          var hasOverflowingTab = tabs.some(function (tab) {
            return tabTextOverflowsHorizontally(tab);
          });

          if (!hasOverflowingTab) break;
          scale -= step;
        }

        if (scale < minScale) {
          setFeaturedTabMobileScale(minScale.toFixed(2));
        }
      }

      function scheduleFeaturedTabFit() {
        if (fitTextRaf) return;
        fitTextRaf = window.requestAnimationFrame(function () {
          fitFeaturedTabTypography();
          fitTextRaf = null;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetIndex = parseInt(tab.getAttribute('data-spclst-featured-product-tab-index') || '0', 10);
          if (isNaN(targetIndex)) return;
          setActiveSlide(targetIndex);
          restartAutoplay();
        });
      });

      sliderRoot.addEventListener(
        'touchstart',
        function (event) {
          clearAutoplay();
          if (!event.touches || !event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      sliderRoot.addEventListener(
        'touchend',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          var touchEndX = event.changedTouches[0].clientX;
          var touchEndY = event.changedTouches[0].clientY;
          var deltaX = touchEndX - touchStartX;
          var deltaY = touchEndY - touchStartY;
          var horizontalSwipe = Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

          if (!horizontalSwipe) return;

          if (deltaX < 0) {
            setActiveSlide(currentIndex + 1);
          } else {
            setActiveSlide(currentIndex - 1);
          }

          startAutoplay();
        },
        { passive: true }
      );

      sliderRoot.addEventListener('wheel', handleFeaturedWheel, { passive: false });

      setActiveSlide(0);
      startAutoplay();
      scheduleFeaturedTabFit();
      window.setTimeout(scheduleFeaturedTabFit, 120);
      window.addEventListener('resize', scheduleFeaturedTabFit);
    });

    queryAll('[data-spclst-revenant-slider]').forEach(function (sliderRoot) {
      if (sliderRoot.getAttribute('data-spclst-initialized') === 'true') return;
      sliderRoot.setAttribute('data-spclst-initialized', 'true');

      var slides = queryAll('.spclst-revenant-main-slide', sliderRoot);
      var dots = queryAll('[data-spclst-revenant-dot]', sliderRoot);
      var currentIndex = 0;
      var autoplayTimer = null;
      var touchStartX = 0;
      var touchStartY = 0;
      var intervalMs = parseInt(sliderRoot.getAttribute('data-spclst-revenant-interval') || '0', 10);

      if (!slides.length) return;

      function normalizeIndex(index) {
        var count = slides.length;
        if (!count) return 0;
        return ((index % count) + count) % count;
      }

      function setActiveSlide(nextIndex) {
        currentIndex = normalizeIndex(nextIndex);

        slides.forEach(function (slide, index) {
          var active = index === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentIndex);
        });
      }

      function clearAutoplay() {
        if (!autoplayTimer) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      function startAutoplay() {
        clearAutoplay();
        if (slides.length < 2) return;
        if (!(intervalMs >= 2000)) return;
        autoplayTimer = window.setInterval(function () {
          setActiveSlide(currentIndex + 1);
        }, intervalMs);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var targetIndex = parseInt(dot.getAttribute('data-spclst-revenant-dot-index') || '0', 10);
          if (isNaN(targetIndex)) return;
          setActiveSlide(targetIndex);
          startAutoplay();
        });
      });

      sliderRoot.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      sliderRoot.addEventListener(
        'touchend',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          var touchEndX = event.changedTouches[0].clientX;
          var touchEndY = event.changedTouches[0].clientY;
          var deltaX = touchEndX - touchStartX;
          var deltaY = touchEndY - touchStartY;
          var horizontalSwipe = Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

          if (!horizontalSwipe) return;

          if (deltaX < 0) {
            setActiveSlide(currentIndex + 1);
          } else {
            setActiveSlide(currentIndex - 1);
          }

          startAutoplay();
        },
        { passive: true }
      );

      setActiveSlide(0);
      startAutoplay();
    });
  };
})();
